export default __webpack_public_path__ + "static/media/Steadfast Armguards.3a0348b3.jpg";